import { createStyles } from '@material-ui/core/styles';

export default createStyles({
    parentContainer: {
        width: '100%',
        padding: '0',
        boxSizing: 'border-box',
        height: 'calc(100% - 125px)',
        overflow: 'auto',
        flexGrow: 1
    },
    worksaleLineDataGrid: {
        'height': '100%',
        'width': '100%',
        '& .dx-header-filter:not(.dx-header-filter-empty) ': {
            color: '#5E9ED6',
          },
    },
    lineDetailIcon: {
        cursor: 'pointer'
    },
    disabledLineDetailIcon: {
        cursor: 'default',
        fill: 'grey'
    }
});
